import type { Dayjs } from 'dayjs';
import type { TextFieldProps } from '@mui/material/TextField';
import type { TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import type { MobileTimePickerProps } from '@mui/x-date-pickers/MobileTimePicker';

import dayjs from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';

// ----------------------------------------------------------------------

type RHFTimePickerProps = TimePickerProps<Dayjs> & {
  name: string;
};

export function RHFTimePicker({ name, slotProps, ...other }: RHFTimePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TimePicker
          {...field}
          value={dayjs(field.value, 'HH:mm')}
          onChange={(newValue) => field.onChange(dayjs(newValue).format('HH:mm'))}
          ampm={false} // This prop ensures the 24-hour format
          format="HH:mm"
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message ?? (slotProps?.textField as TextFieldProps)?.helperText,
              ...slotProps?.textField,
            },
            ...slotProps,
          }}
          {...other}
        />
      )}
    />
  );
}

// ----------------------------------------------------------------------

type RHFMobileTimePickerProps = MobileTimePickerProps<Dayjs> & {
  name: string;
};

export function RHFMobileTimePicker({ name, slotProps, ...other }: RHFMobileTimePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MobileTimePicker
          {...field}
          value={dayjs(field.value, 'HH:mm')}
          onChange={(newValue) => field.onChange(dayjs(newValue).format('HH:mm'))}
          ampm={false} // This prop ensures the 24-hour format
          format="HH:mm"
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message ?? (slotProps?.textField as TextFieldProps)?.helperText,
              ...slotProps?.textField,
            },
            ...slotProps,
          }}
          {...other}
        />
      )}
    />
  );
}
